import { css } from 'styled-system/css';

export const MatchInfoStyles = {
	lobby: css({
		_mars: {
			'& .btn--favorite': {
				_active: {
					color: 'warning.base',
					filter: 'none',
					'& .icon': {
						color: 'currentcolor',
					},
				},
			},

			
			'& .scoreboard__btn .btn--icon .icon--dropdown': {
				color: 'whiteOpacity.54!',
			},
			'& [class^=scoreboard__col] .scoreboard-ball-group .scoreboard-ball': {
				backgroundColor: 'whiteOpacity.30',
				'&:empty': {
					backgroundColor: 'whiteOpacity.12',
				}
			},
		},
	}),
	buttonsTop: css({
		_mars: {
			display: 'flex',
			position: 'relative',
			justifyContent: 'flex-end',
			top: '-6px',
			gap: '6px',
			'& .btn--icon': {
				width: '24px',
				height: '24px',
				flex: '0 0 auto',
			},
		},
	}),
	buttonsBottom: css({
		_mars: {
			display: 'flex',
			position: 'relative',
			justifyContent: 'flex-end',
			bottom: '-6px',
			gap: '6px',
			'& .btn--icon': {
				width: '24px',
				height: '24px',
				flex: '0 0 auto',
			},
		},
	}),
}